"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplashScreen = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const framer_motion_1 = require("framer-motion");
require("./SplashScreen.css");
const logoIcon = require('../../assets/icon.png');
const SplashScreen = ({ onFinish }) => {
    const [progress, setProgress] = (0, react_1.useState)(0);
    const [loadingText, setLoadingText] = (0, react_1.useState)('Başlatılıyor...');
    (0, react_1.useEffect)(() => {
        const loadingSteps = [
            { text: 'Sistem bileşenleri yükleniyor...', duration: 500 },
            { text: 'Arayüz yapılandırılıyor...', duration: 800 },
            { text: 'Sunucu bağlantısı kuruluyor...', duration: 600 },
            { text: 'Meci deneyimi hazırlanıyor...', duration: 400 },
        ];
        let currentStep = 0;
        let currentProgress = 0;
        const progressInterval = setInterval(() => {
            currentProgress += 1.5;
            setProgress(currentProgress);
            if (currentProgress >= 100) {
                clearInterval(progressInterval);
                setTimeout(() => {
                    onFinish();
                }, 500);
            }
        }, 30);
        const textInterval = setInterval(() => {
            if (currentStep < loadingSteps.length) {
                setLoadingText(loadingSteps[currentStep].text);
                currentStep++;
            }
        }, 800);
        return () => {
            clearInterval(progressInterval);
            clearInterval(textInterval);
        };
    }, [onFinish]);
    return ((0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, { children: (0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, { className: "splash-screen", initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { duration: 0.5 }, children: [(0, jsx_runtime_1.jsxs)("div", { className: "splash-content", children: [(0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, { className: "splash-logo-container", initial: { scale: 0.8, opacity: 0 }, animate: { scale: 1, opacity: 1 }, transition: { duration: 0.8, ease: "easeOut" }, children: [(0, jsx_runtime_1.jsx)("img", { src: logoIcon, alt: "Meci Logo", className: "splash-logo-img" }), (0, jsx_runtime_1.jsx)("div", { className: "meci-glow" })] }), (0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, { className: "splash-text-area", initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { delay: 0.5, duration: 0.5 }, children: [(0, jsx_runtime_1.jsx)("h1", { className: "splash-brand-title", children: "MECI" }), (0, jsx_runtime_1.jsx)("p", { className: "splash-brand-subtitle", children: "PROFESYONEL MESAJLA\u015EMA S\u0130STEM\u0130" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "splash-loading-section", children: [(0, jsx_runtime_1.jsx)("div", { className: "splash-progress-track", children: (0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { className: "splash-progress-bar", initial: { width: '0%' }, animate: { width: `${progress}%` } }) }), (0, jsx_runtime_1.jsx)(framer_motion_1.motion.p, { className: "splash-loading-status", initial: { opacity: 0, x: -10 }, animate: { opacity: 1, x: 0 }, children: loadingText }, loadingText)] })] }), (0, jsx_runtime_1.jsx)("div", { className: "splash-footer-meta", children: (0, jsx_runtime_1.jsx)("span", { children: "v6.1.0 - Premium BETA Enterprise" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "splash-bg-effects", children: [(0, jsx_runtime_1.jsx)("div", { className: "bg-blur-blob" }), (0, jsx_runtime_1.jsx)("div", { className: "bg-blur-blob-2" })] })] }) }));
};
exports.SplashScreen = SplashScreen;
